import vuewidget from './vuewidget'
import MiniLoginWidget from '@/pages/MiniLoginWidget.vue'

export default function (dom, opts) {
  // eslint-disable-next-line no-unused-vars
  const widget = vuewidget(dom, {
    vueComponent: MiniLoginWidget,
    vueInit: 'initGlobal',
    ...opts
  })
}
